import femaleImage from 'assets/images/ab_test_313_gender_female.webp'
import maleImage from 'assets/images/ab_test_313_gender_male.webp'

import { Gender } from 'root-constants'

import { TGenderOption } from '../types'

export const ARCHETYPE_GENDER_OPTIONS = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.woman',
    imageUrl: femaleImage,
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.man',
    imageUrl: maleImage,
  },
] as const satisfies readonly TGenderOption[]
